module.exports = function negotiateSignature(event, comparedEvent) {
    if(!event.signature)
        return;
        
    comparedEvent.signature = event.signature;
    comparedEvent.signatureName = event.signatureName;
};
